import React from "react";
import { useSelector } from "react-redux";
import { useFormateMsg } from "../hooks";
const TipsPage = () => {
  const { tipsPage, surveyInfo: info = {} } = useSelector((state) => state.app);
  const { formatMsg } = useFormateMsg();
  const handleRefresh = () => {
    window.location.reload(true);
  };
  let iconfont;
  let txt = formatMsg(`tipsPage.${tipsPage.status}`);
  let subTxt;
  switch (tipsPage.status.toString()) {
    case "success":
      iconfont = "icon-success";
      subTxt = info.showThanks ? info.thanks?.message : undefined;
      break;
    case "network":
      iconfont = "icon-error";
      break;
    case "10003":
    case "10004":
    case "10005":
    case "10006":
    case "10007":
      iconfont = "icon-tips";
      subTxt = formatMsg(`tipsPage.tips.subtxt`);
      break;
    default:
      break;
  }
  return (
    <div className="part-tips-page">
      <div className={`tips-box ${tipsPage.status}`}>
        <i className={`iconfont ${iconfont}`}></i>
        <div className="text">{txt}</div>
        {subTxt && <div className="thanks-content" dangerouslySetInnerHTML={{ __html: subTxt }}></div>}
        {tipsPage.status == "network" && (
          <div className="btn" onClick={handleRefresh}>
            {formatMsg(`tipsPage.refreshBtn`)}
          </div>
        )}
      </div>
    </div>
  );
};

export default TipsPage;
